import React from 'react';
import icon from './shape.svg';

const More = ({ cl, link, moreText = 'Все проекты' }) => {
  return (
    <div className={cl('more-wrapper')}>
      <a className={cl('more')} href={link}>
        <img src={icon} className={cl('more-icon')} />
        {moreText}
      </a>
    </div>
  );
};

export default More;
